class InfiniteLoading extends HTMLElement {
    constructor() {
        super();
        this.isInitialized = false;
    }

    connectedCallback() {
        if (!this.isInitialized) {
            this.initializeComponent();
        }
    }

    initializeComponent() {
        this.mainBlog = this.querySelector('.main-blog');
        this.articlesContainer = this.querySelector('.blog-articles');
        this.loadingSpinner = this.querySelector('.loading-spinner');

        if (!this.mainBlog || !this.articlesContainer || !this.loadingSpinner) {
            return;
        }

        this.page = parseInt(this.dataset.currentPage) || 1;
        this.totalPages = parseInt(this.dataset.totalPages) || 1;
        this.isLoading = false;
        this.hasMorePages = this.page < this.totalPages;

        if (this.hasMorePages) {
            this.setupInfiniteLoading();
        }

        this.isInitialized = true;
    }

    setupInfiniteLoading() {
        const loadingTrigger = document.createElement('div');
        loadingTrigger.className = 'loading-trigger';
        loadingTrigger.innerHTML = `
      <div class="loading-trigger__content">
        <div class="loading-trigger__spinner" aria-hidden="true"></div>
        <span class="loading-trigger__text">Loading more...</span>
      </div>
    `;
        this.mainBlog.appendChild(loadingTrigger);

        this.loadMoreObserver = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (entry.isIntersecting && !this.isLoading && this.hasMorePages) {
                    this.loadMoreArticles();
                }
            },
            {
                root: null,
                rootMargin: '0px 0px 400px 0px',
                threshold: 0.1
            }
        );

        this.loadMoreObserver.observe(loadingTrigger);
    }

    async loadMoreArticles() {
        if (this.isLoading || !this.hasMorePages) return;

        this.isLoading = true;
        this.loadingSpinner.classList.remove('hidden');

        try {
            const nextPage = this.page + 1;
            const baseUrl = window.location.pathname;
            const currentParams = new URLSearchParams(window.location.search);
            currentParams.set('page', nextPage);
            const url = `${baseUrl}?${currentParams.toString()}`;

            const response = await fetch(url);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

            const text = await response.text();
            const html = new DOMParser().parseFromString(text, 'text/html');
            const newArticles = html.querySelectorAll('.blog-articles__article');

            if (newArticles.length > 0) {
                newArticles.forEach(article => {
                    this.articlesContainer.appendChild(article);
                    if (window.Shopify && window.Shopify.designMode) {
                        article.querySelectorAll('[data-cascade]').forEach(element => {
                            element.classList.add('animate--slide-in');
                        });
                    }
                });

                this.page = nextPage;
                this.hasMorePages = this.page < this.totalPages;

                if (!this.hasMorePages) {
                    this.cleanup();
                }
            } else {
                this.hasMorePages = false;
                this.cleanup();
            }
        } catch (error) {
            this.hasMorePages = false;
            this.cleanup();
        } finally {
            this.isLoading = false;
            this.loadingSpinner.classList.add('hidden');
        }
    }

    cleanup() {
        if (this.loadingSpinner) this.loadingSpinner.remove();
        const trigger = this.querySelector('.loading-trigger');
        if (trigger) trigger.remove();
        if (this.loadMoreObserver) {
            this.loadMoreObserver.disconnect();
            this.loadMoreObserver = null;
        }
    }

    disconnectedCallback() {
        this.cleanup();
    }
}

if (!customElements.get('infinite-loading')) {
    customElements.define('infinite-loading', InfiniteLoading);
} 